import {
  BaseFlowModel,
  BaseFlowStepData,
} from '@kinet-open-network/client/flows/data-access';
import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import { SelectionItem } from '@kinet-open-network/shared/data-access/model';
import {
  GoodsReceiptStatus,
  IAppStockItem,
  IFlowGoodsReceipt,
  IFlowGoodsReceiptStepData,
  IFlowOrderScannedItem,
  IFlowOrderSelectionItemData,
  IGoodsReceiptItem,
} from '@kinet-open-network/shared/data-access/model-pbgas';
import { VatRateType } from '@kinet-open-network/shared/util';
import { Type } from 'class-transformer';
import { AppCustomer } from '../../../models/app-customer.model';

type GoodsReceiptSelection = SelectionItem<
  IFlowOrderSelectionItemData,
  IFlowOrderScannedItem
>[];

export class FlowGoodsReceipts
  extends BaseFlowModel<FlowGoodsReceipts, 'GoodsReceipt', string>
  implements IFlowGoodsReceipt
{
  static override readonly modelName = 'GoodsReceipt';

  status!: GoodsReceiptStatus;

  @Type(() => Number)
  customerId!: number;
  @Type(() => Date)
  date!: Date;
  note?: string | null;
  stockCode?: string | null;
  customer?: AppCustomer;
  @Type(() => FlowGoodsReceiptItem)
  items!: FlowGoodsReceiptItem[];
  @Type(() => Number)
  total!: number;
  @Type(() => Number)
  totalBase!: number;
  @Type(() => Number)
  totalVat!: number;
  @Type(() => Date)
  deletedAt?: Date | null;

  @Type(() => SelectionItem)
  receivedItems?: GoodsReceiptSelection;
  @Type(() => SelectionItem)
  returnedItems?: GoodsReceiptSelection;
}

export class FlowGoodsReceiptItem
  extends BaseModel<FlowGoodsReceiptItem, 'GoodsReceipt'>
  implements IGoodsReceiptItem
{
  static override readonly modelName = 'GoodsReceipt';

  orderId!: string;
  stockItemId!: string;
  stockItem?: IAppStockItem;
  @Type(() => Number)
  quantity!: number;
  @Type(() => Number)
  priceBase!: number;
  @Type(() => Number)
  price!: number;
  @Type(() => Number)
  priceVat!: number;
  vatRate!: VatRateType;
  @Type(() => Number)
  sortOrder?: number;
  @Type(() => Number)
  total!: number;
  @Type(() => Number)
  totalBase!: number;
  @Type(() => Number)
  totalVat!: number;

  isFull?: boolean | null;

  isComplaint?: boolean | null;
}

export class FlowGoodsReceiptsStepData
  extends BaseFlowStepData<FlowGoodsReceiptsStepData>
  implements IFlowGoodsReceiptStepData
{
  @Type(() => SelectionItem)
  receivedItems?: GoodsReceiptSelection;

  @Type(() => SelectionItem)
  returnedItems?: GoodsReceiptSelection;
}
